import React from "react";
import PrimaryButton from "../../components/PrimaryButton";
import { Card, Col, Form, Row } from "react-bootstrap";
import CommentPopup from "../../components/CommentPopup";
import {
  capitalizeFirstLetter,
  formatDateTime,
  getRequestType,
} from "../../utils/helpers";
import CustomTable from "../../components/CustomTable";
import {
  itemsTableHeaders,
  itemsTableHeadersForConversion,
  itemsTableHeadersForDamaged,
} from "../../constants/TableConstants";
import useRequestManagementViewViewController from "../../viewControllers/RequestManagementViewControllers/RequestManagementViewViewController";
import Loader from "../../components/Loader";
import i18n from "../../constants/Strings";

const RequestManagementView = () => {
  
  const {
    goBack,
    showPopup,
    handleShowPopup,
    handleClosePopup,
    handleSubmit,
    requestDetails,
    transferSid,
    loading,
  } = useRequestManagementViewViewController();

  const text = {
    backBtn: i18n.t('requestManagement.requestManagementView.backBtn'),
    viewDetails: i18n.t('requestManagement.requestManagementView.viewDetails'),
    transferRequestID: i18n.t('requestManagement.requestManagementView.transferRequestID'),
    requestID: i18n.t('requestManagement.requestManagementView.requestID'),
    requestTime: i18n.t('requestManagement.requestManagementView.requestTime'),
    storeName: i18n.t('requestManagement.requestManagementView.storeName'),
    requestType: i18n.t('requestManagement.requestManagementView.requestType'),
    status: i18n.t('requestManagement.requestManagementView.status'),
    comment: i18n.t('requestManagement.requestManagementView.comment'),
    contactAdmin: i18n.t('requestManagement.requestManagementView.contactAdmin'),
    approveBtn: i18n.t('requestManagement.requestManagementView.approveBtn'),
    rejectBtn: i18n.t('requestManagement.requestManagementView.rejectBtn'),


  }

  return (
    <>
      {loading ? <Loader /> : (
      <div className="container-fluid mt-5">
        <div className="mb-4">
          <div className="card-header py-3">
          <h6 className="back-btn" onClick={goBack}>{text.backBtn}</h6>
            <h6 className="m-0 font-weight-bold txt-primary">
              {text.viewDetails}
            </h6>
          </div>

          <Card style={{ width: "100%", height: "100%" }}>
            <Form className="mt-4 mb-4 px-4">
              {transferSid?.isPresent ? (
                <Row>
                  <Col className="col-lg-6">
                    <h5>
                      {text.transferRequestID}
                      <span className="fs-sm">{transferSid?.value ?? "-"}</span>{" "}
                    </h5>
                  </Col>
                </Row>
              ) : null}
              <Row className="mt-4">
                <Col className="col-lg-6">
                  <h5>
                    {text.requestID}
                    <span className="fs-sm">
                      {requestDetails?.request_id ?? "-"}
                    </span>{" "}
                  </h5>
                </Col>
                <Col className="col-lg-6">
                  <h5>
                    {text.requestTime}
                    <span>
                      {requestDetails?.created_at
                        ? formatDateTime(requestDetails?.created_at)
                        : "-"}
                    </span>{" "}
                  </h5>
                </Col>
              </Row>
              <Row className="mt-4">
                <Col className="col-lg-6">
                  <h5>
                    {text.storeName}
                    <span className="fs-sm">
                      {requestDetails?.store_name ?? "-"}
                    </span>{" "}
                  </h5>
                </Col>
                <Col className="col-lg-6">
                  <h5>
                    {text.requestType}
                    <span>
                      {requestDetails?.request_type
                        ? getRequestType(requestDetails?.request_type)
                        : "-"}
                    </span>{" "}
                  </h5>
                </Col>
              </Row>

              <Row className="mt-4">
                <Col className="col-lg-6">
                  <h5>
                    {text.status}
                    <span className="fs-sm">
                      {requestDetails?.approval_status
                        ? capitalizeFirstLetter(requestDetails?.approval_status)
                        : "-"}
                    </span>{" "}
                  </h5>
                </Col>
                {requestDetails?.comments ? (
                  <Col className="col-lg-6">
                    <h5>
                      {text.comment}
                      <span className="fs-sm">
                        {requestDetails?.comments ?? "-"}
                      </span>{" "}
                    </h5>
                  </Col>
                ) : null}
              </Row>
              {requestDetails?.is_approvable ? null : (
                <Row className="mt-4">
                  <div className="d-flex justify-content-center">
                    <h5 className="required-message">
                      {text.contactAdmin}
                    </h5>
                  </div>
                </Row>
              )}

              {requestDetails?.request_items?.length > 0 ? (
                <Row className="mt-5">
                  {requestDetails?.request_type === "conversion" ? (
                    <CustomTable
                      headers={itemsTableHeadersForConversion}
                      data={requestDetails?.request_items}
                    />
                  ) : requestDetails?.request_type ===
                    "adjustment_for_transfer" ? (
                    <CustomTable
                      headers={itemsTableHeaders}
                      data={requestDetails?.request_items}
                    />
                  ) : requestDetails?.request_type ===
                      "adjustment_for_damaged_items" ||
                    "adjustment_for_lost_items" ? (
                    <CustomTable
                      headers={itemsTableHeadersForDamaged}
                      data={requestDetails?.request_items}
                    />
                  ) : null}
                </Row>
              ) : null}

              {requestDetails?.approval_status === "pending" ? (
                <div className="d-flex justify-content-center mt-5 ">
                  <div className="px-3">
                    {requestDetails?.is_approvable ? (
                      <PrimaryButton
                        text={text.approveBtn}
                        onClick={(e) => handleShowPopup(e, "approved")}
                        className="mt-5"
                      />
                    ) : null}
                  </div>
                  <div>
                    <PrimaryButton
                      text={text.rejectBtn}
                      onClick={(e) => handleShowPopup(e, "rejected")}
                      className="reject-btn mt-5"
                    />
                  </div>
                </div>
              ) : null}
              <CommentPopup
                show={showPopup}
                onHide={handleClosePopup}
                onSubmit={handleSubmit}
              />
            </Form>
          </Card>
        </div>
      </div>
      )}
    </>
  );
};

export default RequestManagementView;
